import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PlatformLocation } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {

  private renderer: Renderer2;

  // Theme Mapping Dictionary
  // Add new merchant channel tags and their corresponding theme names here
  private readonly THEME_MAP: { [key: string]: string } = {
    'XL7EG4F': 'dome-theme',
    'T554H7N': 'oriental-theme',
    'XTFE22M': 'sr-theme'
  };

  constructor(
    @Inject(DOCUMENT) private document: any,
    public rendererFactory: RendererFactory2,
    @Inject(PLATFORM_ID) private platformId: object,
    private platformLocation: PlatformLocation,
  ) { }

  setTheme(theme: any): void {
    if (isPlatformBrowser(this.platformId)) {
      const themeName = Array.isArray(theme) ? theme[0] : theme;
      const themes = theme ? theme : null;
      this.renderer = this.rendererFactory.createRenderer(null, null);
      themes.forEach(t => this.renderer.removeClass(document.body, t));
      this.renderer.addClass(document.body, themeName);

      // Load theme CSS lazily
      const head = this.document.getElementsByTagName('head')[0];
      let themeLink = this.document.getElementById('client-theme') as HTMLLinkElement;

      if (themeLink) {
        themeLink.href = `/${themeName}.css`;
      } else {
        const style = this.document.createElement('link');
        style.id = 'client-theme';
        style.rel = 'stylesheet';
        style.href = `/${themeName}.css`;
        head.appendChild(style);
        themeLink = style;
      }

      // Fallback to default theme if the requested theme CSS fails to load
      themeLink.onerror = () => {
        if (themeName !== 'default-theme') {
          console.warn(`Failed to load ${themeName}.css, falling back to default-theme.`);
          this.setTheme(['default-theme']);
        }
      };
    }
  }

  checkHrefToGetChannelTag() {
    if (isPlatformBrowser(this.platformId)) {
      const href = this.platformLocation.href.toUpperCase();
      let matchedTheme = 'default-theme'; // Default theme fallback

      // Iterate through the theme map to find a matching merchant code in the URL
      for (const [merchantCode, themeName] of Object.entries(this.THEME_MAP)) {
        if (href.includes(merchantCode.toUpperCase())) {
          matchedTheme = themeName;
          break; // Stop searching once we find a match
        }
      }

      this.setTheme([matchedTheme]);
    }
  }
}
